import { Howl } from 'howler';
import helper from '@/includes/helper';

export default {
  state: {
    currentSong: {},
    sound: {},
    seek: '00:00',
    duration: '00:00',
    playerProgress: '0%',
  },
  getters: {
    playing: (state) => {
      if (state.sound.playing) {
        return state.sound.playing();
      }
      return false;
    },
  },
  mutations: {
    newSong: (state, payload) => {
      state.currentSong = payload;
      state.sound = new Howl({
        src: [payload.url],
        html5: true,
      });
    },
    updatePosition: (state) => {
      state.seek = helper.formatTime(state.sound.seek()); // return the current position of the audio being played (in sec)
      state.duration = helper.formatTime(state.sound.duration()); // return the current duration of the song (in sec)
      state.playerProgress = `${
        (state.sound.seek() / state.sound.duration()) * 100
      }%`;
    },
  },
  actions: {
    async newSong({ commit, state, dispatch }, payload) {
      // check the instance of the Howl Object
      if (state.sound instanceof Howl) {
        state.sound.unload(); // pause the current playing audio and delete the instance from the memory
      }
      commit('newSong', payload);

      state.sound.play();

      // event to be listened after the instance of howler available with the audio playing
      state.sound.on('play', () => {
        requestAnimationFrame(() => {
          dispatch('progress');
        });
      });
    },
    async toggleAudio({ state }) {
      if (!state.sound.playing) {
        return;
      }

      if (state.sound.playing()) {
        state.sound.pause();
      } else {
        state.sound.play();
      }
    },
    progress({ commit, state, dispatch }) {
      commit('updatePosition');

      // if the song is playing
      if (state.sound.playing()) {
        // redispatching is required because requestAnimationFrame function runs only once.
        requestAnimationFrame(() => {
          dispatch('progress');
        });
      }
    },
    updateSeek({ state, dispatch }, payload) {
      if (!state.sound.playing) {
        return;
      }

      const { x, width } = payload.currentTarget.getBoundingClientRect(); // return information of currently clicked elements coordinates and dimensions
      const clickX = payload.clientX - x; // return the horizontal coordinate of the click (payload represents the event object here)
      const percentage = clickX / width; // gives the position to move the audio to
      const seconds = state.sound.duration() * percentage;

      state.sound.seek(seconds); // update the song duration to the position selected

      // Howl emit this event when audio has officially changed position
      state.sound.once('seek', () => {
        dispatch('progress');
      });
    },
  },
};
